// eslint-disable-next-line import/no-webpack-loader-syntax
import MarkdownFile from '!!raw-loader!../../CHANGELOG.md';
import Markdown from 'react-markdown';

export const Changelog = () => {
    return <div className='container overflow-auto full-height'>
        <Markdown>{MarkdownFile}</Markdown>
    </div>
};